import {
  ApolloClient,
  NormalizedCacheObject,
  useLazyQuery,
  useQuery,
} from '@apollo/client';
import { GetSpeakersQuery, GetSpeakersQueryVariables } from 'graphql/types';
import SPEAKERS_QUERY from 'graphql/speaker/queries/speakers.graphql';

export const useSpeakers = (variables: GetSpeakersQueryVariables) =>
  useQuery<GetSpeakersQuery, GetSpeakersQueryVariables>(SPEAKERS_QUERY, {
    variables,
  });

export const useLazySpeakers = () =>
  useLazyQuery<GetSpeakersQuery, GetSpeakersQueryVariables>(SPEAKERS_QUERY);

export const getSpeakersSsr = async (
  client: ApolloClient<NormalizedCacheObject>,
  variables: GetSpeakersQueryVariables
) => {
  try {
    return client.query({ query: SPEAKERS_QUERY, variables });
  } catch (err) {
    console.log(err);
  }
};
